import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  cronJob,
  getPaymentHistories,
  getUserPaymentHistory,
  paymentStatus,
} from "./Api";

const initialState = {
  payment: [],
  paymentStatus: [],
  payments: [],
  loading: false,
  error: null,
};

export const getPaymentStatus = createAsyncThunk(
  "stripe/paymentStatus",
  async () => {
    try {
      const response = await paymentStatus();
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const getAllPaymentHistories = createAsyncThunk(
  "stripe/paymentAllHistory",
  async () => {
    try {
      const response = await getPaymentHistories();
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const getPaymentHistory = createAsyncThunk(
  "stripe/getPaymentHistory",
  async () => {
    try {
      const response = await getUserPaymentHistory();
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const startCronJob = createAsyncThunk(
  "cronjob/startCronJob",
  async (data) => {
    try {
      const response = await cronJob(data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPaymentStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentStatus = action.payload;
        state.error = null;
      })
      .addCase(getAllPaymentHistories.fulfilled, (state, action) => {
        state.loading = false;
        state.payments = action.payload;
        state.error = null;
      })
      .addCase(getPaymentStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default paymentSlice.reducer;
